/** Full-page assistant canvas — matches AppLayout / nav page shell background. [2.2.1450] */
export const ASSISTANT_PAGE_BG_CLASS = 'bg-gray-50 dark:bg-gray-900';

/** Rail layout uses the same canvas as the full-page assistant. */
export const ASSISTANT_RAIL_BG_CLASS = ASSISTANT_PAGE_BG_CLASS;

/** Rail composer card — same raised panel as full-page assistant. */
export const ASSISTANT_RAIL_COMPOSER_CLASS =
  'overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-600 dark:bg-gray-800';
